import { render, staticRenderFns } from "./answerCart.vue?vue&type=template&id=30a0df7a&scoped=true"
import script from "./answerCart.vue?vue&type=script&lang=js"
export * from "./answerCart.vue?vue&type=script&lang=js"
import style0 from "./answerCart.vue?vue&type=style&index=0&id=30a0df7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a0df7a",
  null
  
)

export default component.exports